export default {
  '***': {
    '***': [
      {
        "id": 10,
        "label": "Brand Image",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [
          25,
          30,
          50
        ],
        "tooltip": "This will be checked automatically when any item in this section is checked."
      },
      {
        "id": 25,
        "label": "Customer Service",
        "selected": 0,
        "collapse": 0,
        "parent": 10,
        "children": [],
        "tooltip": "Refers to a primary focus on customer service"
      },
      {
        "id": 30,
        "label": "Co-Brand",
        "selected": 0,
        "collapse": 0,
        "parent": 10,
        "children": [],
        "tooltip": "Single ad advertising for more than one brand ('Seamless + Taco Bell' or 'Marriott Chase credit card')"
      },

      {
        "id": 50,
        "label": "Sponsorship",
        "selected": 0,
        "collapse": 0,
        "parent": 10,
        "children": [],
        "tooltip": "Sponsorship of an event, sport or project (such as a food bank)"
      },

      {
        "id": 100,
        "label": "Creative Type",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [
          110,
          120,
          130,
          140
        ],
        "tooltip": "This will be checked automatically when any item in this section is checked."
      },
      {
        "id": 110,
        "label": "Narrative",
        "selected": 0,
        "collapse": 0,
        "parent": 100,
        "children": [],
        "tooltip": "Ad follows a story trajectory, even if short"
      },
      {
        "id": 120,
        "label": "Vignette/Montage",
        "selected": 0,
        "collapse": 0,
        "parent": 100,
        "children": [],
        "tooltip": "Ad does not have a story, but rather many different scenes cut together"
      },
      {
        "id": 130,
        "label": "Animated",
        "selected": 0,
        "collapse": 0,
        "parent": 100,
        "children": [],
        "tooltip": "At least half of ad is cartoon/animation and not filmed"
      },
      {
        "id": 140,
        "label": "Graphics/Product Images Only",
        "selected": 0,
        "collapse": 0,
        "parent": 100,
        "children": [],
        "tooltip": "Ad is a computer generated ad usually focusing on a product with few or no actual filmed scenes/beauty shots"
      },
      {
        "id": 1,
        "label": "Creative Style",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9
        ],
        "tooltip": "This will be checked automatically when any item in this section is checked."
      },
      {
        "id": 2,
        "label": "Humorous",
        "selected": 0,
        "collapse": 0,
        "parent": 1,
        "children": [],
        "tooltip": "The intent of the ad is to make you laugh"
      },
      {
        "id": 3,
        "label": "Emotional",
        "selected": 0,
        "collapse": 0,
        "parent": 1,
        "children": [],
        "tooltip": "The intent of the ad is to elicit sad or heartwarming emotion"
      },
      {
        "id": 4,
        "label": "Spokesperson",
        "selected": 0,
        "collapse": 0,
        "parent": 1,
        "children": [],
        "tooltip": "Includes both celebrity and non-celebrity spokespeople"
      },
      {
        "id": 5,
        "label": "Celebrity (for brand NOT content)",
        "selected": 0,
        "collapse": 0,
        "parent": 1,
        "children": [],
        "tooltip": "Includes any celebrity inclusion, whether or not that person is a spokesperson"
      },
      {
        "id": 6,
        "label": "Music (jingle)",
        "selected": 0,
        "collapse": 0,
        "parent": 1,
        "children": [],
        "tooltip": "Refers to a consistent jingle associated with a brand, not just background music"
      },
      {
        "id": 7,
        "label": "Music (lyrics/song)",
        "selected": 0,
        "collapse": 0,
        "parent": 1,
        "children": [],
        "tooltip": "Refers to an identifiable song - either lyrics or instrumental"
      },
      {
        "id": 8,
        "label": "Branding in Intro (First 5 seconds)",
        "selected": 0,
        "collapse": 0,
        "parent": 1,
        "children": [],
        "tooltip": "The advertising brand is shown or spoken in the first 5 seconds"
      },
      {
        "id": 9,
        "label": "Voice Over Narration",
        "selected": 0,
        "collapse": 0,
        "parent": 1,
        "children": [],
        "tooltip": "An off-screen narrator is featured"
      },

      {
        "id": 200,
        "label": "Influencer",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [
          201,
          202
        ],
        "tooltip": "This will be checked automatically when any item in this section is checked."
      },
      {
        "id": 201,
        "label": "Yes",
        "selected": 0,
        "collapse": 0,
        "parent": 200,
        "children": [],
        "tooltip": "Ad uses an influencer to deliver the message"
      },
      {
        "id": 202,
        "label": "No",
        "selected": 0,
        "collapse": 0,
        "parent": 200,
        "children": [],
        "tooltip": "Ad does not use an influencer to deliver the message"
      },

      {
        "id": 300,
        "label": "Partner/Employee Presence",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [
          301,
          302
        ],
        "tooltip": "This will be checked automatically when any item in this section is checked."
      },
      {
        "id": 301,
        "label": "Yes",
        "selected": 0,
        "collapse": 0,
        "parent": 300,
        "children": [],
        "tooltip": "Ad features a partner/employee"
      },
      {
        "id": 302,
        "label": "No",
        "selected": 0,
        "collapse": 0,
        "parent": 300,
        "children": [],
        "tooltip": "Ad does not feature a partner/employee"
      },
    ]
  }
};


// WEBPACK FOOTER //
// ./src/app/configuration/HEB/config/components/selection/Search/tagHierarchy.js